import { DataSource } from 'types/datasource';
import { TasticProps } from 'frontastic/tastics/types';
import Head from 'components/microhead';

const ProductSEO = ({ data }: TasticProps<DataSource<any>>) => {
  const product = data?.data?.dataSource?.product;
  return (
    <>
      <Head
        title={product.metaTitle || ''}
        metaDescription={product.metaDescription || ''}
        metaKeywords={product.metaKeywords || ''}
      ></Head>
    </>
  );
};

export default ProductSEO;
